
export default {
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setCompany(state, company) {
    state.company = company;
  },
  setCompanyLogo(state, companyLogo) {
    state.companyLogo = companyLogo;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/company/store/mutations.js